/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as Tags from './trans-website-checkout-deliverynudging-tags';
export * as DawaSuggestionModal from './trans-website-checkout-deliverynudging-dawasuggestionmodal';
export * as ChooseSupplierModal from './trans-website-checkout-deliverynudging-choosesuppliermodal';
export * as EveningModal from './trans-website-checkout-deliverynudging-eveningmodal';
export * as ExpressModal from './trans-website-checkout-deliverynudging-expressmodal';
export * as TypeAddressModal from './trans-website-checkout-deliverynudging-typeaddressmodal';
export * as ValidationFlow from './trans-website-checkout-deliverynudging-validationflow';

export const RecommendedDeliveryHeadline = 'Website.Checkout.DeliveryNudging.RecommendedDeliveryHeadline';
export const SelectedDeliveryOptionHeading = 'Website.Checkout.DeliveryNudging.SelectedDeliveryOptionHeading';
export const ShowMore = 'Website.Checkout.DeliveryNudging.ShowMore';
export const Edit = 'Website.Checkout.DeliveryNudging.Edit';
export const NoResultsDidYouMeanText = 'Website.Checkout.DeliveryNudging.NoResultsDidYouMeanText';
